module.exports = __webpack_public_path__ + "img/handshake.b01b0c22.png";